import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  ListItem,
  ListItemIcon,
  List,
  ListItemText,
  Paper,
  Divider,
  Collapse,
  ListItemButton,
  ListItemAvatar,
  Avatar,
} from "@mui/material";
import styled from "styled-components";
import HomeIcon from "@mui/icons-material/Home";
import GroupsIcon from "@mui/icons-material/Groups";
import SportsHandballIcon from "@mui/icons-material/SportsHandball";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
//import { selectTeams, selectPositions} from '../../reducers/FrontReducer';
import { TeamLogos, TeamNames, PositionList } from "../../globals/Globals";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ExpandableListItem from "./ExpandableList";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import BuildIcon from "@mui/icons-material/Build";
import { useAppDispatch } from "../../hooks";
import { ToggleThemeMode } from "../../state/reducers/UserSettingsReducer";
import ThemeSwitch from "../Theming/ThemeSwitch";
import SportsCricketIcon from "@mui/icons-material/SportsCricket";
import PanToolIcon from "@mui/icons-material/PanTool";

export interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const TOOLS = [{ url: "VCLoopHole", name: "VC Loophole" }];

const MyDrawer = styled(Drawer)`
  height: 100%;
  .MuiPaper-root {
    height: 100%;
    padding: 1rem;
    background-color: rgb(13, 21, 37);
    border-top-right-radius: 5%;
    border-bottom-right-radius: 5%;
    color: white;
    width: 300px;
  }
  .MuiListItemText-primary {
    font-size: 1.2rem;
  }
`;
const MyDivider = styled(Divider)`
  background-color: white;
  padding-left: 1rem;
  margin-bottom: 0.5rem !important;
  margin-top: 0.5rem !important;
`;
const MyAvatar = styled(Avatar)`
  img {
    object-fit: contain;
  }
  background-color: transparent;
  .MuiAvatar-root {
    background-color: transparent;
  }
`;

const POSITIONAMES = {
  BAT: "Batters",
  BWL: "Bowlers",
  WKP: "Wicket Keepers",
};

const PositionIcons = {
  BAT: SportsCricketIcon,
  BWL: SportsHandballIcon,
  WKP: PanToolIcon,
};

const mypaper = (
  <Paper style={{ height: "100%", backgroundColor: "#rgb(13, 21, 37)" }} />
);

function NavDrawer({ open, setOpen }: Props) {
  const router = useNavigate();
  const dispatch = useAppDispatch();
  const [teamsOpen, setTeamsOpen] = useState(false);

  let teamitems = TeamNames.map(function (team) {
    return (
      <ListItem onClick={(e) => router(`/team/${team}`)}>
        <ListItemAvatar>
          <MyAvatar alt={team} src={TeamLogos[team]} />
        </ListItemAvatar>
        <ListItemText primary={team} />
      </ListItem>
    );
  });

  let positionitems: React.ReactNode[] = PositionList.map(function (position) {
    let TheIcon = PositionIcons[position];
    return (
      <ListItem onClick={(e) => router(`/position/${position}`)}>
        <ListItemAvatar>
          <MyAvatar alt={position} className="positionAvatar">
            {<TheIcon style={{ width: 34, height: 34, color: "white" }} />}
          </MyAvatar>
        </ListItemAvatar>
        <ListItemText primary={POSITIONAMES[position]} />
      </ListItem>
    );
  });

  let toolitems: React.ReactNode[] = TOOLS.map(function (tool) {
    return (
      <ListItem onClick={(e) => router(`/tool/${tool.name}`)}>
        <ListItemText primary={tool.name} />
      </ListItem>
    );
  });

  return (
    <MyDrawer
      open={open}
      onClose={(e) => setOpen(!open)}
      style={{ height: "100%" }}
      sx={{ height: "100%" }}
      PaperProps={mypaper}
      className="navdrawer"
    >
      <div
        style={{
          backgroundImage: `url('/images/icons/Logo-Blue-White.svg')`,
          backgroundSize: "contain",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          height: "3rem",
          width: "100%",
          marginBottom: "2rem",
        }}
      ></div>
      <Box
        //role="presentation"
        style={{ height: "100%" }}
        sx={{
          height: "100%",
          overflowX: "scroll",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <List>
          <ListItem onClick={(e) => router("/")}>
            <ListItemIcon>
              <HomeIcon style={{ color: "white" }} />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
          <MyDivider />
          <ExpandableListItem
            items={teamitems}
            headingText="Teams"
            icon={<GroupsIcon style={{ color: "white" }} />}
          />
          <MyDivider />
          <ExpandableListItem
            items={positionitems}
            headingText="Positions"
            icon={<SportsHandballIcon style={{ color: "white" }} />}
          />
          <MyDivider />
          <ListItem onClick={(e) => router("/search")}>
            <ListItemIcon>
              <SearchIcon style={{ color: "white" }} />
            </ListItemIcon>
            <ListItemText primary="Search" />
          </ListItem>
          <MyDivider />
          <ListItem onClick={(e) => router("/compareplayers")}>
            <ListItemIcon>
              <CompareArrowsIcon style={{ color: "white" }} />
            </ListItemIcon>
            <ListItemText primary="Compare Players" />
          </ListItem>
          <MyDivider />
          {/* <ExpandableListItem items={toolitems} headingText="Tools" icon={<BuildIcon style={{color: "white"}}/>} /> */}
          {/* <MyDivider/> */}
          <ListItem onClick={(e) => router("/findplayers")}>
            <ListItemIcon>
              <PersonSearchIcon style={{ color: "white" }} />
            </ListItemIcon>
            <ListItemText primary="Find A Player" />
          </ListItem>
          <MyDivider />
          <ListItem onClick={(e) => router("/scteams")}>
            <ListItemIcon>
              <PersonSearchIcon style={{ color: "white" }} />
            </ListItemIcon>
            <ListItemText primary="SCTeams" />
          </ListItem>
        </List>
        <div style={{ marginTop: "auto" }}>
          <ThemeSwitch />
        </div>
        <div>
          <b>Sponsored By</b>
          <div
            style={{
              backgroundImage: `url('https://scplaybook.com.au/wp-content/themes/scpb_2022-04-14_12-27/dist/assets/images/mortgagechoicename2_1.svg')`,
              backgroundSize: "contain",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
              height: "3rem",
              width: "100%",
              marginTop: "1rem",
            }}
          ></div>
        </div>
      </Box>
    </MyDrawer>
  );
}

export default NavDrawer;
